var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { uniqBy } from "lodash";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import MAXIMUM_REWARD_RECIPIENTS from "@irati/reward/constants/maximumRewardRecipients";
import UserSearch from "@irati/ui/src/UserSearch";
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet";
import SelectedUser from "./Checkout/Steps/Recipients/SelectedUser";
import { FlexRow } from "./styled";
var Recipients = /** @class */ (function (_super) {
    __extends(Recipients, _super);
    function Recipients() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasTrackingEventFired: false
        };
        _this.handleClick = function () {
            if (_this.props.isCredit && !_this.state.hasTrackingEventFired) {
                rewardWalletTracking.clickUserDropdown();
                _this.setState({ hasTrackingEventFired: true });
            }
        };
        _this.addRecipient = function (_, user) {
            if (user) {
                var _a = _this.props, recipients = _a.recipients, setRecipients = _a.setRecipients, isCredit = _a.isCredit;
                if (isCredit) {
                    rewardWalletTracking.selectUser();
                }
                setRecipients(uniqBy(recipients.concat(user), "uuid"));
            }
        };
        _this.removeUser = function (removeUser) {
            var _a = _this.props, recipients = _a.recipients, setRecipients = _a.setRecipients;
            setRecipients(recipients.filter(function (user) { return user !== removeUser; }));
        };
        return _this;
    }
    Recipients.prototype.render = function () {
        var _this = this;
        var _a = this.props, recipients = _a.recipients, allowMultipleRecipients = _a.allowMultipleRecipients;
        var showSearch = allowMultipleRecipients ? recipients.length < MAXIMUM_REWARD_RECIPIENTS : recipients.length < 1;
        var recipientsLimitReached = recipients.length >= MAXIMUM_REWARD_RECIPIENTS;
        return (React.createElement(Row, null,
            React.createElement(Col, { md: 12 },
                showSearch && (React.createElement(FlexRow, { onClick: this.handleClick },
                    React.createElement(UserSearch, { id: "recipients-selector", hideLabel: true, removeSelf: true, onChange: this.addRecipient, placeholder: "platform.fields.selectRecipient.placeholder", controlShouldRenderValue: false, hint: allowMultipleRecipients &&
                            !recipientsLimitReached && (React.createElement(FormattedMessage, { id: recipients.length > 0 ? "platform.recipients.list.recipientsHint" : "platform.recipients.list.recipientsHintDefault", values: { count: MAXIMUM_REWARD_RECIPIENTS - recipients.length } })) }))),
                allowMultipleRecipients && recipientsLimitReached && (React.createElement("h4", null,
                    React.createElement(FormattedMessage, { id: "platform.recipients.list.maxRecipientsMsg" }))),
                recipients.map(function (user, index) { return (React.createElement(SelectedUser, { key: user.uuid, index: index, removeUser: _this.removeUser, user: user })); }))));
    };
    Recipients.defaultProps = {
        allowMultipleRecipients: true
    };
    return Recipients;
}(PureComponent));
export default Recipients;
